import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { getSimpleMissionLink } from '../../../Utils/Link'
import { unbookMissionById } from '../../../Reducers/Mission/actions'
import {
  hideUnbookModal,
  unbookModalChange,
} from '../../../Reducers/UI/actions'
import { UNBOOK_OPTIONS } from '../../../constants'
import UnbookModalView from '../component/UnbookModalView'

const UnbookModal = ({ mission }) => {
  const [disabled, setDisabled] = useState(false)

  const show = useSelector(state => state.ui.unbookModal.show)
  const reason = useSelector(state => state.ui.unbookModal.reason)
  const onConfirm = useSelector(state => state.ui.unbookModal.onConfirm)
  const title = useSelector(state => state.ui.unbookModal.title)
  const text = useSelector(state => state.ui.unbookModal.text)

  const dispatch = useDispatch()
  const history = useHistory()

  const handleConfirmUnbook = async () => {
    setDisabled(true)
    const missionLink = getSimpleMissionLink(mission.id)

    await dispatch(
      unbookMissionById({
        missionId: mission.id,
        unbookReason: reason,
      }),
    )

    dispatch(hideUnbookModal())
    if (onConfirm) {
      onConfirm(reason)
    }
    setDisabled(false)
    history.push(`${missionLink}`.replace('/edit', ''))
  }
  const onReasonChange = (e, index, value) => {
    dispatch(unbookModalChange({ reason: value }))
  }

  return (
    <UnbookModalView
      handleCancel={() => dispatch(hideUnbookModal())}
      handleConfirm={handleConfirmUnbook}
      show={show}
      onReasonChange={onReasonChange}
      value={reason}
      options={UNBOOK_OPTIONS}
      title={title}
      disabled={disabled}
      text={text}
    />
  )
}

export default UnbookModal



// WEBPACK FOOTER //
// ./src/Components/UnbookModal/container/UnbookModal.js